import * as React from 'react'
import { LabeledCheckbox } from './checkbox'
import { Label } from './input'
import { Repository } from '@basehub/data/replicache/index'

export interface RepoSelectorProps {
  repositories: Repository[]
  selectedRepoIds: string[]
  onSelectionChange: (selectedRepoIds: string[]) => void
  label?: string
  className?: string
  maxHeight?: string
}

export const RepoSelector: React.FC<RepoSelectorProps> = ({
  repositories,
  selectedRepoIds,
  onSelectionChange,
  label,
  className,
  maxHeight = '448px',
}) => {
  const setAll = React.useCallback(
    (value: boolean) => {
      if (value) {
        onSelectionChange(repositories.map((r) => r.id))
      } else {
        onSelectionChange([])
      }
    },
    [onSelectionChange, repositories]
  )

  return (
    <div className={className}>
      {label && (
        <Label label={label} blocked className="!py-5 !pt-0" size="xs" />
      )}
      <div className="border rounded-lg border-dark-border-solid bg-dark-base-dark text-dark-dim">
        <LabeledCheckbox
          className="px-3 py-2 !text-dark-dim !text-xs"
          labelClassName="font-medium"
          horizontal={'reverse'}
          name="all"
          label={`Select all (${repositories.length}) repositories`}
          checkboxProps={{
            onCheckedChange: setAll,
            checked: selectedRepoIds.length === repositories.length,
          }}
        />
        {repositories.length > 0 && (
          <>
            <hr className="w-full border-dark-border-solid" />
            <div
              className="overflow-y-auto flex flex-col gap-y-1.5 py-2 px-3"
              style={{ maxHeight }}
            >
              {repositories.map((repo) => (
                <LabeledCheckbox
                  labelClassName="[&>span]:!font-normal"
                  key={repo.id}
                  className="!text-dark-dim"
                  name={repo.id}
                  horizontal="reverse"
                  label={repo.title}
                  checkboxProps={{
                    checked: selectedRepoIds.includes(repo.id),
                    onCheckedChange: (value) => {
                      onSelectionChange(
                        value
                          ? [...selectedRepoIds, repo.id]
                          : selectedRepoIds.filter((id) => id !== repo.id)
                      )
                    },
                  }}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  )
}
